import { getWidgetView } from './getWidgetView.js'

export const isActiveCall = (get) => {
  const view = getWidgetView(get().widget_tab)
  return view === 'ringing' || view === 'in-progress'
}
